import { Container } from "react-bootstrap";

export default function ({
  className = "py-5 pt-md-6",
  description,
  interesting_fact,
  why_hrs,
  awards,
  theme = "light",
}) {
  return (
    <div className={className} data-bs-theme={theme}>
      <Container fluid="md" className="mw-xl border-bottom">
        <div className="mb-5" dangerouslySetInnerHTML={{ __html: description }} />
        {interesting_fact && (
          <div className="mb-5">
            <h3 className="h6 text-green">Interesting Fact</h3>
            <div dangerouslySetInnerHTML={{ __html: interesting_fact }} />
          </div>
        )}
        {why_hrs && (
          <div className="mb-5">
            <h3 className="h6 text-green">Why HRS?</h3>
            <div dangerouslySetInnerHTML={{ __html: why_hrs }} />
          </div>
        )}
        {awards && (
          <div className="mb-5">
            <h3 className="h6 text-green">Awards</h3>
            <div dangerouslySetInnerHTML={{ __html: awards }} />
          </div>
        )}
      </Container>
    </div>
  );
}
